import { Link } from "@/components/common/Link";
import { Facebook, Linkedin, Mail, MapPin, Twitter } from "lucide-react";
export default function UtilityBar() {
  const socials = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <section id="utilitybar" className="w-full bg-primary py-2 text-sm font-sans text-primary-foreground">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 sm:flex-row sm:gap-0 lg:px-8">
        
        {}
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
          <div className="flex items-center gap-2">
            <Mail className="size-4 shrink-0" />
            <Link to="mailto:team@quitmytimeshare.com" className="transition-opacity hover:opacity-80">
              team@quitmytimeshare.com
            </Link>
          </div>
          
        </div>

        {}
        <div className="flex items-center gap-4">
          {socials.map((social, i) => {
          const Icon = social.icon;
          return <Link key={i} to={social.href} data-index={i} className="transition-opacity hover:opacity-80" aria-label={social.label}>
                <Icon className="size-4" />
              </Link>;
        })}
        </div>

      </div>
    </section>;
}